<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable max-width="350px">
      <template v-slot:activator="{ on, attrs }">
        <v-row class="d-flex justify-end mr-1 mt-n4">
          <v-btn color="primary" dark v-bind="attrs" v-on="on" small> Transferir </v-btn>
        </v-row>
      </template>
      <v-card>
        <v-card-title>Seleccionar Profesional</v-card-title>
        <v-card-subtitle class="text-body-2 pt-2"
          >Elija al receptor de las historias clínicas.</v-card-subtitle
        >
        <v-divider></v-divider>
        <v-card-text style="height: 300px">
          <v-radio-group
            v-model="inputProfes"
            column
            @input="updateInputProfes"
            @change="updateInputProfes"
            v-for="(item, index) in recordProfes"
            :key="index"
          >
            <v-radio :label="item.profesFullname" :value="item.instProfesId"></v-radio>
          </v-radio-group>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="d-flex justify-space-between">
          <v-btn color="blue darken-1" text @click="dialog = false"> Cerrar </v-btn>
          <v-btn color="blue darken-1" text @click="(dialog = false), saveTransfer()">
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'VDialogTransfer',
  props: ['dialogItem', 'recordProfes', 'saveTransfer', 'updateInputProfes'],
  data() {
    return {
      dialogm1: '',
      dialog: false,
      inputProfes: null,
    };
  },
  watch: {
    value: {
      handler(after) {
        this.input = after;
      },
      immediate: true,
    },
  },
  methods: {
    insertRoute(ruta) {
      this.$router.push(ruta);
      this.$route.query;
    },
  },
};
</script>
